// Google Analytics 4 do site do Colégio Líder.
//
// Cole aqui o "ID da métrica" da propriedade do Google Analytics
// (começa com G-, por exemplo 'G-AB12CD34EF'). Enquanto estiver vazio,
// o site funciona normalmente e simplesmente não envia nada ao Google.
//
// Onde achar: analytics.google.com → Administrador → Fluxos de dados →
// (fluxo do site) → "ID da métrica".
export const GA_MEASUREMENT_ID = 'G-RCFCK39V2P';
